import * as actionCreators from '../../redux/internal/actionCreators';
import React from 'react';
import { connect } from 'react-redux';

import Button from '../../../../../primitives/form/button/Button';
import TextField from '../../../../../primitives/form/TextField/TextField';

export class ConfirmDialog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: '',
    };

    this.buttonIsDisabled = this.buttonIsDisabled.bind(this);
    this.onClickHandler = this.onClickHandler.bind(this);
    this.onHandleKeyDown = this.onHandleKeyDown.bind(this);
  }

  buttonIsDisabled() {
    const { currentTrialName } = this.props;
    if (!currentTrialName) {
      return true;
    }

    const { value } = this.state;
    const btnStatus = value.replace(/\s/g, '') !== currentTrialName.replace(/\s/g, '');

    return btnStatus;
  }

  onClickHandler = () => {
    this.props.setConfirmDialogCompleted(true);
  };

  onHandleKeyDown = (e) => {
    if (e.keyCode == 13) {
      !this.buttonIsDisabled() && this.onClickHandler();
      e.preventDefault();
    }
  };

  render() {
    const { currentTrialName } = this.props;
    const { value } = this.state;

    return (
      <div className="uploader__form">
        <p>
          To upload to this library, confirm it is the correct choice by typing the trial name into the box.
          <span>
            The complete trial name is: <b>{currentTrialName}</b>
          </span>
        </p>

        <form className="form form__center" autoComplete="off" noValidate>
          <div className="form__group-wrapper uploader__form--input">
            <div className="form__group">
              <TextField
                value={value}
                handleKeyDown={(e) => {
                  this.onHandleKeyDown(e);
                }}
                handleChange={(e) => {
                  this.setState({ value: e.target.value });
                }}
                fieldName="Trial name"
                showError={false}
              />
            </div>
          </div>
          <Button
            name="Confirm"
            buttonType="primary"
            elementType="button"
            actionType="button"
            handleClick={this.onClickHandler}
            disable={this.buttonIsDisabled()}
          />
        </form>
      </div>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    currentTrialName: state.internal.currentTrialName,
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    setConfirmDialogCompleted: (value) => {
      // istanbul ignore next
      dispatch(actionCreators.setConfirmDialogCompleted(value));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmDialog);
